import { ddMMyyyy } from '@/utils/convert'
import { Badge } from '@surein/ui'
import { X } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { FilterState } from './Filters'
import {
  StyledFiltersDisplay,
  StyledRelativeContainer,
  StyledXButton,
} from './styles'

type CurrentlyAppliedFiltersProps = {
  filters: FilterState
  onRemove: (key: keyof FilterState) => void
}

const CurrentlyAppliedFilters = ({
  filters,
  onRemove,
}: CurrentlyAppliedFiltersProps) => {
  const { t } = useTranslation()

  const hasStatus = filters.status.length > 0
  const hasInsurance = filters.insuranceCategories.length > 0

  return (
    <StyledFiltersDisplay>
      {hasStatus && (
        <Badge variant="success" size="lg">
          <StyledRelativeContainer>
            <span>{t('claimsPage.table.status')}:</span>
            <span>{filters.status.length}</span>
            <StyledXButton
              variant="outline"
              size="sm"
              icon={X}
              onClick={() => onRemove('status')}
            />
          </StyledRelativeContainer>
        </Badge>
      )}

      {hasInsurance && (
        <Badge variant="success" size="lg">
          <StyledRelativeContainer>
            <span>{t('claimsPage.table.insurance')}:</span>
            <span>{filters.insuranceCategories.length}</span>
            <StyledXButton
              variant="outline"
              size="sm"
              icon={X}
              onClick={() => onRemove('insuranceCategories')}
            />
          </StyledRelativeContainer>
        </Badge>
      )}

      {filters.date?.from && filters.date?.to && (
        <Badge variant="success" size="lg">
          <StyledRelativeContainer>
            <span>{t('claimsPage.table.date')}:</span>
            <span>
              {ddMMyyyy(filters.date.from)} - {ddMMyyyy(filters.date.to)}
            </span>
            <StyledXButton
              variant="outline"
              size="sm"
              icon={X}
              onClick={() => onRemove('date')}
            />
          </StyledRelativeContainer>
        </Badge>
      )}
    </StyledFiltersDisplay>
  )
}

export default CurrentlyAppliedFilters
